<template>
  <Modal :id="id" title="Merge Users" :hideFooter="true">
    <div slot="body" class="modal-body">
        <div v-if="!!error" class="alert alert-danger">
          <div v-for="err in error">
            {{ err }}
          </div>
        </div>
	    <div class="text-center mb-5">
		    <p>
			    <a href="/storage/imports/samples/user-bulk-import-example.csv">Download this sample CSV</a>
			    file to use as a template for your import file.
		    </p>
        <p>
          The Company IDs used for account creation are NOT HVACpartner or Aviator IDs.  They are MyLC IDs.
        </p>
        <p class="text-danger">PROCEED WITH CAUTION.</p>
	    </div>
        <div class="dropzone" :id="dropzoneId">
	        <div class="text-center">
	          <button type="button" class="btn btn-primary">Choose File</button>
	        </div>
	        <div class="dropzone-preview mt-3"></div>
        </div>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import Dropzone from "dropzone";
export default {
	mixins: [ModalMixin],
	data() {
		return {
			id: "bulk-users-import",
			dropzoneId: "dz-import-users",
			error: null,
		};
	},
	mounted() {
		let me = this;
		let token = document.head.querySelector('meta[name="csrf-token"]');
		Dropzone.autoDiscover = false;

		me.dropzone = new Dropzone(`#${me.dropzoneId}`, {
			url: me.route("admin.users.bulk-import"),
			paramName: "import_file",
			withCredentials: true,
			headers: { "X-CSRF-Token": token.content },
			clickable: `#${me.dropzoneId} button`,
			previewsContainer: `#${me.dropzoneId} .dropzone-preview`,
			hiddenInputContainer: `#${me.dropzoneId} .dropzone-preview`,
			thumbnailMethod: "contain",
		});

		me.dropzone.on("success", (file, response) => {
			setTimeout(() => {
				me.dropzone.removeFile(file);
				this.resolve();
			}, 3000);
		});

		me.dropzone.on("error", (file, response) => {
			console.log(response);
			this.error = response;
		});
	},
};
</script>

<style>
#dz-import-users {
	border: none;
	min-height: 0;
	padding: 0;
}
</style>
